import gsap from 'gsap';

const ImageIn = (element) => {
  const tl = gsap.timeline();
  tl.to(element.querySelector('.image__picture-actual'), {
    scale: 1,
    ease: 'expo.out',
    duration: 1.2,
  });
  return tl;
};

export default ImageIn;
